/**
 * This function checks to see if the user has a grassroot persona as his role
 * This function relies on Userdata.
 * It should return false under any condition other than the case where Userdata.user_persona is one of the grassroots value.
 * @name isGrassrootsPersona
 * @function
 * @returns {Boolean} - true if is grassroots, false if not
 */
export const isGrassrootsPersona = () => {
    const grassrootsPersonas = [
        DjangIO.app.userdata.types.UserPersona.grassroots_nonprofit_director.value,
        DjangIO.app.userdata.types.UserPersona.grassroots_corp_director.value,
        DjangIO.app.userdata.types.UserPersona.grassroots_associate.value,
    ]

    return grassrootsPersonas.includes(Userdata.user_persona)
}
